
        var result = require("!!../../../../node_modules/css-loader/index.js!./inactivity.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-planner/inactivity.component.css
// module id = 2439
// module chunks = 1